export default __webpack_public_path__ + "static/agency_lhsh-d489ecabf26ede91f4b6a379c1a83c0a.svg";